import apiRequest from "./apiConfig";
import { apiVersion } from "./endpoints";

const BASE_URL = process.env.REACT_APP_API_BASE_URL + apiVersion.version;

export function getLiveAttendanceEmployees(query) {
  return apiRequest({
    method: "get",
    url: `${BASE_URL}/employee`,
    query,
    timeout: 15000,
  });
}

export function markEmployeeLogin({ employeeReferenceId, dateTime }) {
  return apiRequest({
    method: "post",
    url: `${BASE_URL}/attendance/mark/simple`,
    query: {
      employeeReferenceId,
      dateTime,
      swipeInOrSwipeOut: "SWIPE_IN",
    },
  });
}
